// extracted by mini-css-extract-plugin
export default {"title_style":"SingleDeviceBoard_title_style__KvAEY","wrapperPadding":"SingleDeviceBoard_wrapperPadding__t53CF"};